import React from "react";
import { Icon } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import type { IconProps } from "@chakra-ui/react";

interface CustomIconProps {
  icon: IconType;
  size?: number;
  color?: string;
}

export const CustomIcon: React.FC<CustomIconProps> = ({
  icon: IconComponent,
  size = 20,
  color,
}) => {
  const Element = IconComponent as React.ComponentType<IconProps>;
  return (
    <Icon
      verticalAlign="middle"
      as={Element}
      boxSize={`${size}px`}
      color={color}
    />
  );
};
